import { render } from "./PayDeductionListDialog.vue?vue&type=template&id=4a61e7a6"
import script from "./PayDeductionListDialog.vue?vue&type=script&lang=js"
export * from "./PayDeductionListDialog.vue?vue&type=script&lang=js"

import "./PayDeductionListDialog.vue?vue&type=style&index=0&id=4a61e7a6&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__